/* eslint-disable import/no-extraneous-dependencies */
import { rest } from 'msw';
import { randomId } from '@/common/utils';
import { AssetEditBody } from '@/views/assets/interfaces';

/**
 * Receives a path and return it transformed with
 * Asset editor optimizer URI
 * @param path - Request path
 * @returns - Asset Editor URI
 */
function mockEditorUri(path: string) {
  return process.env.VUE_APP_ASSETS_OPTIMIZER_URI + path;
}

/**
 * Receive a value and return it transformed
 * with specific percentage
 * @param value - Value to update
 * @param percentage - Percentage to transform
 * @returns Value transformed
 */
function updateValue(value: number, percentage: number) {
  return Math.round(value * (percentage / 100));
}

export const assetEditorRequests = (msw: typeof rest) => [
  msw.post(mockEditorUri('/images/crop'), (req, res, ctx) => {
    const body = req.body as AssetEditBody;
    const { assetSize, mockData } = body.options;
    const { coordinates, size } = mockData;

    return res(
      ctx.status(200),
      ctx.delay(1500),
      ctx.json({
        createdAt: Date.now(),
        expiresAt: Date.now(),
        url: body.input.url,
        updatedAt: Date.now(),
        meta: {
          ...coordinates,
          width: updateValue(coordinates.width, size),
          height: updateValue(coordinates.height, size),
          size: updateValue(assetSize, size),
        },
        storage: {
          bucket: `development-optimizer-assetsbucket-${randomId()}`,
          key: `optimized/images/${randomId()}.png`,
        },
      }),
    );
  }),

  msw.post(mockEditorUri('/images/resize'), (req, res, ctx) => {
    const body = req.body as AssetEditBody;
    const { assetSize, mockData, resize } = body.options;
    const { size } = mockData;

    return res(
      ctx.status(200),
      ctx.delay(1500),
      ctx.json({
        createdAt: Date.now(),
        expiresAt: Date.now(),
        url: body.input.url,
        updatedAt: Date.now(),
        meta: {
          width: updateValue(resize.width, size),
          height: updateValue(resize.height, size),
          size: updateValue(assetSize, size),
        },
        storage: {
          bucket: `development-optimizer-assetsbucket-${randomId()}`,
          key: `optimized/images/${randomId()}.png`,
        },
      }),
    );
  }),

  msw.post(mockEditorUri('/images/compress'), (req, res, ctx) => {
    const body = req.body as AssetEditBody;
    const { assetSize, quality, resize } = body.options;

    return res(
      ctx.status(200),
      ctx.delay(1500),
      ctx.json({
        createdAt: Date.now(),
        expiresAt: Date.now(),
        url: body.input.url,
        updatedAt: Date.now(),
        meta: {
          width: resize.width,
          height: resize.height,
          size: updateValue(assetSize, quality),
        },
        storage: {
          bucket: `development-optimizer-assetsbucket-${randomId}`,
          key: `optimized/images/${randomId}.png`,
        },
      }),
    );
  }),
];

export default assetEditorRequests;
